import * as React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/system';
import vector from '../../../../../src/assets/images/Vector.png';
import Ellipse from '../../../../../src/assets/images/Ellipse1.png';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination, Navigation } from 'swiper';

const ImagePreviewContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  width: '366px',
  maxHeight: '114px',
  dropShadow: '0px 2px 4px rgba(0, 0, 0, 0.45)',
  [theme.breakpoints.down('md')]: {
    width: '366px',
  },
}));

const ImageBox = styled('div')(() => ({
  position: 'relative',
  '& img': {
    position: 'relative',
    width: '82px',
    height: '113px',
    objectFit: 'cover',
  },
}));

const VectorBox = styled('div')(() => ({
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '25px',
  height: '22px',
  right: '0px',
  top: '0px',
  backgroundImage: `url(${Ellipse})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  '& img': {
    width: '11px',
    height: '11px',
  },
}));

export default function ImagePreview({ images, deleteHandler }) {
  return (
    <ImagePreviewContainer>
      <>
        <Swiper
          slidesPerView={4}
          spaceBetween={10}
          slidesPerGroup={4}
          loop={false}
          loopFillGroupWithBlank={true}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          modules={[Pagination, Navigation]}
          style={{
            '--swiper-navigation-color': 'rgba(0, 0, 0, 0.54)',
            '--swiper-navigation-size': '10px',
            width: '386px',
            margin: '0 -10px',
            padding: '0 10px',
          }}
          dots="false"
          className="mySwiper"
        >
          <>
            <button
              className=" swiper-button-prev "
              style={{
                left: '0px',
                border: '1px solid #D9D9D9',
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
                boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
                height: '20px',
                width: '20px',
                cursor: 'pointer',
                borderRadius: '10px',
                fontWeight: '700',
              }}
            ></button>
            <button
              className=" swiper-button-next "
              style={{
                right: '0px',
                border: '1px solid #D9D9D9',
                backgroundColor: 'rgba(255, 255, 255, 0.6)',
                boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
                height: '20px',
                width: '20px',
                cursor: 'pointer',
                borderRadius: '10px',
                fontWeight: '700',
              }}
            ></button>
          </>
          {images.map((image, index) => {
            return (
              <SwiperSlide key={index}>
                <ImageBox>
                  <img src={image.url} />
                  <VectorBox onClick={() => deleteHandler(index)}>
                    <img src={vector} />
                  </VectorBox>
                </ImageBox>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </>
    </ImagePreviewContainer>
  );
}
